import React from 'react';
import PropTypes from 'prop-types';
import fr from 'facet-rest';
import { MetaResourceRenderer } from 'Components/UI/Meta/MetaForm/Components/MetaResourceRenderer';
import { buildFacetDesignOverride, overrideReadOnly } from 'Packages/FacetRest/FacetDesignOverride';
import { DisplayTextSmall, TextInputLarge, TitleTextLarge } from 'Packages/FacetDesign/Components';
import { FDBodyText, FDHeadlineText } from '@facet-wealth/design';
import Layout from './Layout';

const metaOverrideSet = buildFacetDesignOverride()
  .nameOverride('title', {
    _component: () => DisplayTextSmall,
    _customProps: {
      color: 'textSecondary',
    },
  }, overrideReadOnly)
  .nameOverride('header', {
    _component: () => TitleTextLarge,
  }, overrideReadOnly)
  .nameOverride('question', {
    _component: () => TextInputLarge,
    _customProps: {
      rows: 3,
      fullWidth: true,
    },
  })
  .nameOverride('taxYearHeader', {
    _component: () => FDHeadlineText,
    _customProps: {
      size: 'sm',
      align: 'center',
    },
  }, overrideReadOnly)
  .nameOverride('disclosure', {
    _component: FDBodyText,
    _customProps: {
      size: 'sm',
      align: 'center',
    },
  }, overrideReadOnly)
  .done();

const Template = ({ resource }) => {
  return (
    <MetaResourceRenderer
      layout={Layout}
      resource={resource}
      metaOverrideSet={metaOverrideSet}
    />
  );
};

Template.defaultProps = {
};

Template.propTypes = {
  resource: PropTypes.instanceOf(fr.Resource).isRequired,
};

export default Template;
